import {
  ChangeDetectionStrategy,
  Component,
  TemplateRef,
  computed,
  input
} from '@angular/core';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzTooltipModule } from 'ng-zorro-antd/tooltip';

type AlertTooltipType = 'danger' | 'warning' | 'info' | 'alert';

@Component({
  selector: 'moxi-alert-tooltip-icon',
  imports: [
    // Ant Design
    NzIconModule,
    NzTooltipModule
  ],
  templateUrl: './alert-tooltip-icon.component.html',
  styleUrl: './alert-tooltip-icon.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class AlertTooltipIconComponent {
  tooltip = input.required<string | TemplateRef<void>>();
  type = input<AlertTooltipType>('info');

  icon = computed(() => this.getIconFromType(this.type()));
  classColor = computed(() => this.getColorFromType(this.type()));

  private getIconFromType(type: AlertTooltipType): string {
    switch (type) {
      case 'danger':
        return 'warning';
      case 'warning':
        return 'exclamation-circle';
      case 'alert':
        return 'exclamation-circle';
      default:
        return 'info-circle';
    }
  }

  private getColorFromType(type: AlertTooltipType): string {
    switch (type) {
      case 'danger':
        return 'alert-color';
      case 'warning':
        return 'warning-color';
      case 'alert':
        return 'alert-color';
      default:
        return 'info-color';
    }
  }
}
